export const BASE_URL =
  process.env.NODE_ENV == "development"
    // ? "https://qiyue.smxjoiai.xyz/"
    ?"https://28dshare.com/"
    : "https://18dtt.com/";
// http://18dtt.com
export const ENDPOINT_URL = process.env.NODE_ENV == "development" ? "https://test.shopeelive.co" : "https://test.shopeelive.co";

export const REQUEST_API = {
  userRegister: "member/member/register",
  userConfig: "member/member/configure/1",
  userLogin: "member/member/login",
  getcode: "member/system/getCaptchaImage",
  goPageUrl: process.env.NODE_ENV == "development"?"/api/file/domain/8d":'/file/domain/8d',
  createCustomer: "https://8d.waebox.com/api/v3/customer/createCustomerInfo",
    endpointReg: "/register",
    endpointLogin: "/login"
};



// WEBPACK FOOTER //
// ./src/utils/api.js